var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer-box" }, [
    _c("div", { staticClass: "nav" }, [
      _c("dl", { staticClass: "services" }, [
        _c("dt", [_vm._v("商家服务")]),
        _c(
          "dd",
          [
            _c("nuxt-link", { attrs: { to: "/services/oa" } }, [
              _vm._v("OA办公")
            ])
          ],
          1
        ),
        _c(
          "dd",
          [
            _c("nuxt-link", { attrs: { to: "/services/crm" } }, [
              _vm._v("客户管理")
            ])
          ],
          1
        ),
        _c(
          "dd",
          [
            _c("nuxt-link", { attrs: { to: "/services/wms" } }, [
              _vm._v("仓库管理")
            ])
          ],
          1
        ),
        _c(
          "dd",
          [
            _c("nuxt-link", { attrs: { to: "/services/shop" } }, [
              _vm._v("商城管理")
            ])
          ],
          1
        ),
        _c(
          "dd",
          [
            _c("nuxt-link", { attrs: { to: "/services/fms" } }, [
              _vm._v("财务管理")
            ])
          ],
          1
        ),
        _c(
          "dd",
          [
            _c("nuxt-link", { attrs: { to: "/services/marketing" } }, [
              _vm._v("营销中心")
            ])
          ],
          1
        ),
        _c(
          "dd",
          [
            _c("nuxt-link", { attrs: { to: "/services/application" } }, [
              _vm._v("系统应用")
            ])
          ],
          1
        )
      ]),
      _vm._m(0),
      _vm._m(1)
    ]),
    _vm._m(2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "contact" }, [
      _c("dt", [_vm._v("联系我们")]),
      _c("dd", [
        _c("p", [_vm._v("业务咨询：18669659922")]),
        _c("p", [_vm._v("周一到周六 8:00 ~ 18:00")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "download" }, [
      _c("span", [
        _c("img", {
          attrs: { src: require("static/callcenter.png"), alt: "呼叫中心" }
        }),
        _c("p", [_vm._v("呼叫中心APP下载")])
      ]),
      _c("span", [
        _c("img", {
          attrs: { src: require("static/wms.png"), alt: "仓储管理" }
        }),
        _c("p", [_vm._v("仓储管理APP下载")])
      ]),
      _c("span", [
        _c("img", { attrs: { src: require("static/app.png"), alt: "saas" } }),
        _c("p", [_vm._v("SAAS APP下载")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icp" }, [
      _c("p", [
        _vm._v(
          "Copyright © 2023 www.eainger.com. All Rights Reserved 山东易安捷科技股份有限公司版权所有 增值电信业务经营许可证：鲁B2-20160094 备案号：鲁ICP备19015890号-1"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a6ce840", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a6ce840","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/layouts/main/Footer.vue
// module id = 5F/E
// module chunks = 1 3